import { useCallback } from 'react';

import { NumberFieldProps } from '../number-field.types';

import { useStepper, UseStepperProps } from './use-stepper';

type UseNumberFormatProps = Pick<NumberFieldProps, 'onBlur' | 'onValueChange'> & {
  stepperProps: UseStepperProps;
};

export function useNumberFormat(props: UseNumberFormatProps) {
  const stepper = useStepper(props.stepperProps);
  const handleBlur = useCallback(
    (e: React.FocusEvent<HTMLInputElement>) => {
      const input = props.stepperProps.inputRef.current;
      if (!input) return;

      // format and apply the value
      stepper()?.applyNextValue(input.value);
      props.onBlur?.(e);
    },
    [props, stepper]
  );

  return { handleBlur };
}
